import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ApprovalL3WoGridComponent } from '../approval-l3-wo-grid/approval-l3-wo-grid.component';
import { ApprovalFilterForm, WorkOrderFilterForm } from '../../../form-model/work-order-filter.form.model';
import { WorkOrderSearchTextForm } from '../../../form-model/work-order-search-text.form.model';
import { ApprovalWoService } from '../../../services/approval-wo.service';

@Component({
  selector: 'app-approval-l3-header',
  imports: [FormsModule, ReactiveFormsModule, RouterModule, ApprovalL3WoGridComponent],
  templateUrl: './approval-l3-header.component.html',
  styleUrl: './approval-l3-header.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ApprovalL3HeaderComponent {
  selectedTabVal: string = 'MyQueue';
  showGrid: boolean = true;
  @Input({ required: true }) filterFormGroup!: FormGroup<{
    workOrderFilterForm: FormGroup<ApprovalFilterForm>;
    workOrderSearchTextForm: FormGroup<WorkOrderSearchTextForm>;
  }>;
  @Output() tabVal = new EventEmitter();
  setIndex: number = 0;
  constructor(private approvalService: ApprovalWoService) {}

  ngOnInit() {
    this.approvalService.currTabVal?.subscribe((msg) => {
      this.selectedTabVal = msg;
    });
    if (this.selectedTabVal === 'MyQueue') {
      this.setIndex = 0;
    } else if (this.selectedTabVal === 'MyPool') {
      this.setIndex = 1;
    } else {
      this.setIndex = 0;
      this.selectedTabVal = 'MyQueue';
    }
  }

  onTabChanged(event: Event) {
    let customEvent = event as CustomEvent;
    let selectedTab = customEvent.detail;
    this.showGrid = false;
    setTimeout(() => {
      this.selectedTabVal = selectedTab === 0 ? 'MyQueue' : 'MyPool';
      this.approvalService.sendSelectedTabVal(this.selectedTabVal);
      this.tabVal.emit(this.selectedTabVal);
      this.showGrid = true;
    });
  }
}
